import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import Menu from "./Menu";
// import Header from './Header';
import ThemeSetting from "./ThemeSetting";
import Searchbar from "./Searchbar";
import SecurityRoute from "./securityRoute";
import BrandRoute from "./brandRoute";
import BreachRoute from "./breachRoute";
import QuantumRoute from "./quantumRoute";
import ServiceRoute from "./serviceRoute";
import kbRoute from "./kbRoute";
import SummaryNew from "../Dashboard/summary_bk";
import { AnimatePresence } from "framer-motion/dist/framer-motion.dev";
import AssetDiscovery from "../SecurityRisk/assetsdiscovery";
import Clients from "../Projects/Clients";
import ShowInformation from "../information/ShowInformation";
import User from "../Dashboard/user";
import PageProfile from "../Pages/pageProfile";
import RemediationRoute from "./remediationModeRoute";
import AboutUs from "../Pages/AboutUs";
import CompanyProfile from "../Pages/CompanyProfile";
import ContactUs from "../Pages/ContactUs";
import LegalInfo from "../Pages/LegalInfo";
import PrivacyInfo from "../Pages/PrivacyInfo";
import PartnersInfo from "../Pages/PartnersInfo";
import LicensesCertifications from "../Pages/LicensesCertifications";

// Admin Panel
import AdminRoute from "./adminRoute";
import AdminStartScreen from "../Dashboard/AdminStartScreen";


const Layout = (props) => {
  return (
    <>
      {/* <ThemeSetting /> */}
      <div id="wrapper">
        <Searchbar />
        <div className="assignment_mode_security_health_check">
          <AnimatePresence>
            <Switch>
              <Route key="admin" path="/admin" component={AdminRoute} />
              <Route exact={true} key="dashboard" path="/summary" component={SummaryNew} />
              <Route exact={true} path="/user/:id" component={User} />
              <Route exact={true} path="/user" component={User} />
              <Route exact={true} path="/profile" component={PageProfile} />
              <Route exact path={["/about", "/about-us"]} component={AboutUs} />
              <Route exact={true} path="/company-profile" component={CompanyProfile} />
              <Route exact={true} path="/contact" component={ContactUs} />
              <Route exact={true} path="/legal" component={LegalInfo} />
              <Route exact={true} path="/privacy" component={PrivacyInfo} />
              <Route exact={true} path="/partners" component={PartnersInfo} />
              <Route exact={true} path="/licenses" component={LicensesCertifications} />
              <Route key="remediation-mode" path="/remediation-mode" component={RemediationRoute} />
              <Route key="security" path="/security" component={SecurityRoute} />
              <Route key="services" path="/services" component={ServiceRoute} />
              <Route key="kb" path="/kb" component={kbRoute} />
              <Route key="brand" path="/brand" component={BrandRoute} />
              <Route key="breach" path="/breach" component={BreachRoute} />
              <Route key="quantum" path="/quantum" component={QuantumRoute} />
              <Route exact={true} key="dashboard" path="/" component={SummaryNew} />
              <Route exact={true} key="dashboard" path="/assets" component={AssetDiscovery} />
              <Route key="brand" path="/client" component={Clients} />
              <Route key="show-information" path="/show-details/:id" component={ShowInformation} />
            </Switch>
          </AnimatePresence>
        </div>
      </div>
    </>
  );
};

export default Layout;
